import { Steps as StepsAnt } from 'antd';
import styled from 'styled-components';

const Steps = styled(StepsAnt)`
  position: sticky;
  top: 0;
  height: calc(100vh - 113px);
  background-color: #43aa58;

  .ant-steps-item-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    & > .ant-steps-item-tail {
      display: none !important;
    }

    & > .ant-steps-item-content {
      & > .ant-steps-item-title {
        color: #fff;
      }
    }
  }

  .ant-steps-item-icon {
    & > .ant-steps-icon {
      color: #fff !important;
    }
  }

  .ant-steps-item {
    &.ant-steps-item-active {
      background-color: #3e9a51;

      &:not(:last-child) {
        .ant-steps-item-container {
          &::after {
            content: '';
            position: absolute;
            left: calc(50% - 20px);
            top: 100%;
            width: 0;
            height: 0;
            border-left: 20px solid transparent;
            border-right: 20px solid transparent;
            border-top: 16px solid #3e9a51;
            clear: both;
          }
        }
      }
    }
  }

  .ant-steps-item-finish {
    background-color: #3e9e52;
  }
`;

export default { Steps };
